// PO6-S1-F2 (docs/backlog.md; docs/build-briefs/PO6-S1-F2-placed-by-
// approved-by-show-a-name.md). Found and fixed as a bug on the purchase
// order detail screen ("Placed by <raw employee UUID>"), then swept
// across the rest of ui/src for the identical shape: a resolved
// displayName field with no name-shown fallback other than the raw
// employee/user id. Every one of those screens now imports this ONE
// function rather than inventing its own wording, so the fallback text
// cannot drift between them the way it already had (ui/src/main.ts's
// void-history row uses the separate, deliberately different "Not
// recorded" wording for a genuinely absent actor -- see that module's own
// comment -- which is why this is not reused there: "Former employee" is
// specifically for an id that exists but no longer resolves to a current
// users row, never for "no one did this").
//
// Kept DOM-free, the same reason ui/src/purchasingDisplay.ts,
// ui/src/catalogDisplay.ts and ui/src/managerExceptionDisplay.ts are: a
// plain node:test file can import this directly, where ui/src/main.ts
// itself cannot (its top-level mustFind calls run at import time and
// require a real DOM).
export const FORMER_EMPLOYEE_FALLBACK = "Former employee";

/** displayName straight through when it resolved; FORMER_EMPLOYEE_FALLBACK
 * otherwise. Never the raw id: every call site passes this function the
 * resolved displayName field alone, never the id, so there is no id for
 * this function to fall back to even by mistake. */
export function resolveActorDisplayName(displayName: string | null): string {
  return displayName ?? FORMER_EMPLOYEE_FALLBACK;
}
